import { Component, OnInit, ViewEncapsulation, ViewChild, Output, EventEmitter, Input } from '@angular/core';

import { DropzoneConfigInterface, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { AlertService } from './../../../shared/services/alert.service';
import { AuthenticationService } from './../../../shared/services/authentication.service';

const SUCCESS_MESSAGE = 'Soubor byl úspěšně uložen.';
const ERROR_MESSAGE = 'Při nahrávání se něco pokazilo.';

@Component({
  selector: 'swb-dropzone',
  templateUrl: './dropzone.component.html',
  styleUrls: ['./dropzone.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DropzoneComponent implements OnInit {

  @ViewChild(DropzoneDirective) directiveRef: DropzoneDirective;

  @Output() queueCompleted: EventEmitter<string> = new EventEmitter<any>();
  @Output() fileUploaded: EventEmitter<string> = new EventEmitter<any>();

  @Input() imgOnly = false;
  @Input() mimeType = null;

  public config: DropzoneConfigInterface;


  constructor(
    private _alertService: AlertService
  ) { }

  ngOnInit() {
    if (this.imgOnly) {
      this.config = {
        headers: { 'Authorization': 'Bearer ' + AuthenticationService.getBearerToken() },
        acceptedFiles: 'image/jpeg, image/png, image/gif, image/svg+xml'
      };
    } else if(this.mimeType) {
      this.config = {
        headers: { 'Authorization': 'Bearer ' + AuthenticationService.getBearerToken() },
        acceptedFiles: this.mimeType
      };
    } else {
      this.config = { headers: { 'Authorization': 'Bearer ' + AuthenticationService.getBearerToken() } };
    }
  }

  public onUploadError($event) {
    this._alertService.error(ERROR_MESSAGE);
  }

  public onUploadSuccess($event) {
    this.fileUploaded.emit($event);
    this._alertService.success(SUCCESS_MESSAGE);
  }

  public onQueueComplete($event) {
    this.queueCompleted.emit($event);
    this.directiveRef.reset();
  }

}
